export default __webpack_public_path__ + "static/media/client9.52d9fb6a.jpg";